import { delay, dictApi, } from '@/apis'

const listToJson = list => list.reduce((o, item) => {
  return { ...o, [item['dictCode']]: item['dictName'] }
}, {})

const user = {
  namespaced: true,
  state: {
    client: {}
  },
  mutations: {
    setClient(state, client) {
      state.client = client
    },
  },
  actions: {
    async getDict(content) {
      const clientDictTag = ['认证状态']
      const dictTag = [...clientDictTag]
      const data = await dictApi.base(({ dictTag: dictTag.join('|') }))
      const dataKeys = Object.keys(data)

      content.commit('setClient', {
        '认证状态': listToJson(data['认证状态'])
      })
    },
  },
  getters: {
    client: state => state.client,
    clientSelect: state => {
      const keys = Object.keys(state.client)
      if (keys.length) {
        return keys.reduce((o, key) => {
          const entries = Object.entries(state.client[key])
          console.log('entries', entries)
          return { ...o, [key]: entries.map(item => ({ label: item[1], value: item[0] })) }
        }, {})
      }
      return {}
    },
  }
}

export default user